import styled from 'styled-components';

export const FlightDetailModal = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing.x6} ${theme.spacing.x4}`};
  width: 100%;
`;
export const GrayCard = styled.div`
  padding: ${({ theme }) => theme.spacing.x4};
  margin: ${({ theme }) => ` ${theme.spacing.x3} 0`};
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  span {
    padding: ${({ theme }) => theme.spacing.x1};
  }
`;
export const BtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Btn = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const FlightDetailModalContainer = styled.div`
  width: 566px;
  max-width: 95%;
`;
